/**
 * HeatmapLayer — renders a Leaflet heatmap from incident data points.
 * Uses leaflet.heat plugin.
 */
import { useMap } from 'react-leaflet';
import { useEffect, useRef } from 'react';
import L from 'leaflet';

try { require('leaflet.heat'); } catch (e) { console.warn('leaflet.heat not loaded', e); }

export const HeatmapLayer = ({ points, visible }) => {
  const map = useMap();
  const heatRef = useRef(null);

  useEffect(() => {
    if (!map || !L.heatLayer) return;

    if (heatRef.current) {
      map.removeLayer(heatRef.current);
      heatRef.current = null;
    }

    if (visible && points?.length > 0) {
      heatRef.current = L.heatLayer(points, {
        radius: 28,
        blur: 20,
        maxZoom: 14,
        max: 1.0,
        minOpacity: 0.35,
        gradient: {
          0.2: '#22c55e',
          0.45: '#eab308',
          0.65: '#f97316',
          0.85: '#ef4444',
          1.0: '#991b1b',
        },
      }).addTo(map);
    }

    return () => {
      if (heatRef.current) {
        map.removeLayer(heatRef.current);
        heatRef.current = null;
      }
    };
  }, [map, points, visible]);

  return null;
};
